import React, { useEffect, useState } from "react";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import CollapseCard from "../Components/CollapseCard";
import Modal from "../Components/Modal";
import ContractorPaymentForm from "../Components/ContractorPaymentForm";
import ContractorPaymentList from "../Components/ContractorPaymentList";
import { useToast } from "../Components/toast/ToastProvider";
import { Button } from "react-bootstrap";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "react-feather";
import { formatDate } from "../config/function";


import {
  getAllContractorPayments,
  getContractorPaymentByFilter,
  saveContractorPayment,
  updateContractorPayment,
  deleteContractorPayment,
} from "../Service/ContractorPaymentService";

import { getAllContractors } from "../Service/ContractorService";

const ContractorPayment = () => {

  const [paymentData, setPaymentData] = useState([]);

  const [contractors, setContractors] = useState([]);

  const [paymentForm, setPaymentForm] = useState({
    contractor_id: "",
    date: "",
    amount: "",
    remarks: "",
  });

  const [filters, setFilters] = useState({
    contractor_id: "",
    from_date: "",
    to_date: "",
  });

  const [showModal, setShowModal] = useState(false);

  const toast = useToast();


  /*
  |--------------------------------------------------------------------------
  | INITIAL LOAD
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    fetchPayments();
    fetchContractors();
  }, []);


  /*
  |--------------------------------------------------------------------------
  | FETCH ALL PAYMENTS
  |--------------------------------------------------------------------------
  */

  const fetchPayments = async () => {

    try {

      const res = await getAllContractorPayments();

      setPaymentData(res.data || []);

    } catch (err) {

      toast(
        err.message || "Failed to fetch contractor payments",
        "ERROR"
      );

    }
  };


  /*
  |--------------------------------------------------------------------------
  | FETCH CONTRACTORS
  |--------------------------------------------------------------------------
  */

  const fetchContractors = async () => {

    try {

      const res = await getAllContractors();

      setContractors(res.data || []);

    } catch (err) {

      toast(
        err.message || "Failed to fetch contractors",
        "ERROR"
      );

    }
  };


  /*
  |--------------------------------------------------------------------------
  | FORM SUBMIT
  |--------------------------------------------------------------------------
  */

  const handleSubmit = async (e) => {

    e.preventDefault();


    if (
      !paymentForm.contractor_id ||
      !paymentForm.date ||
      !paymentForm.amount
    ) {

      toast(
        "Please fill all fields",
        "ERROR"
      );

      return;
    }


    if (Number(paymentForm.amount) <= 0) {

      toast(
        "Amount must be greater than zero",
        "ERROR"
      );

      return;
    }


    try {

      if (paymentForm.id) {

        await updateContractorPayment(paymentForm);

        toast(
          "Contractor payment updated successfully",
          "SUCCESS"
        );

      } else {

        await saveContractorPayment(paymentForm);

        toast(
          "Contractor payment added successfully",
          "SUCCESS"
        );

      }


      // Refresh current filter
      await fetchFilteredPayments();

      handleCancel();

    } catch (err) {

      toast(
        err.message || "Failed to save contractor payment",
        "ERROR"
      );

    }
  };


  /*
  |--------------------------------------------------------------------------
  | FORM CHANGE
  |--------------------------------------------------------------------------
  */

  const handleChange = (e) => {

    const {
      name,
      value
    } = e.target;

    setPaymentForm((prev) => ({
      ...prev,
      [name]: value,
    }));

  };


  /*
  |--------------------------------------------------------------------------
  | EDIT
  |--------------------------------------------------------------------------
  */

  const handleEdit = (item) => {

    setPaymentForm({
      id: item.id,
      contractor_id: item.contractor_id,
      date: item.date,
      amount: item.amount,
      remarks: item.remarks || "",
    });

    setShowModal(true);

  };


  /*
  |--------------------------------------------------------------------------
  | DELETE
  |--------------------------------------------------------------------------
  */

  const handleDelete = async (id) => {

    if (!window.confirm("Are you sure you want to delete this payment?")) {
      return;
    }


    try {

      await deleteContractorPayment(id);

      toast(
        "Contractor payment deleted successfully",
        "SUCCESS"
      );

      await fetchFilteredPayments();

    } catch (err) {

      toast(
        err.message || "Delete failed",
        "ERROR"
      );

    }
  };


  /*
  |--------------------------------------------------------------------------
  | FILTER CHANGE
  |--------------------------------------------------------------------------
  */

  const handleFilterChange = (e) => {

    const {
      name,
      value
    } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));

  };


  /*
  |--------------------------------------------------------------------------
  | APPLY FILTER
  |--------------------------------------------------------------------------
  */

  const handleFilter = async () => {

    if (
      filters.from_date &&
      filters.to_date &&
      filters.from_date > filters.to_date
    ) {

      toast(
        "From date cannot be greater than To date",
        "ERROR"
      );

      return;
    }


    await fetchFilteredPayments();

  };


  /*
  |--------------------------------------------------------------------------
  | FETCH FILTERED PAYMENTS
  |--------------------------------------------------------------------------
  */

  const fetchFilteredPayments = async () => {

    try {

      const res = await getContractorPaymentByFilter(filters);

      setPaymentData(res.data || []);

    } catch (err) {

      toast(
        err.message || "Failed to fetch contractor payments",
        "ERROR"
      );

    }
  };


  /*
  |--------------------------------------------------------------------------
  | CLEAR FILTER
  |--------------------------------------------------------------------------
  */

  const handleClearFilter = async () => {

    const clearFilters = {
      contractor_id: "",
      from_date: "",
      to_date: "",
    };

    setFilters(clearFilters);


    try {

      const res = await getContractorPaymentByFilter(
        clearFilters
      );

      setPaymentData(res.data || []);

    } catch (err) {

      toast(
        err.message || "Failed to fetch contractor payments",
        "ERROR"
      );

    }
  };


  /*
  |--------------------------------------------------------------------------
  | CANCEL FORM
  |--------------------------------------------------------------------------
  */

  const handleCancel = () => {

    setPaymentForm({
      contractor_id: "",
      date: "",
      amount: "",
      remarks: "",
    });

    setShowModal(false);

  };

   const addPDFHeader = (doc, pageWidth) => {
    const logo = new Image();
    logo.src = "/img/asa_logo.png";

    const logoWidth = 18;
    const logoHeight = 18;
    const spacing = 5;

    const headerText = "ASA Transport";
    const subHeaderText = "Mannargudi";

    const headerWidth = doc.getTextWidth(headerText);
    const subHeaderWidth = doc.getTextWidth(subHeaderText);
    const totalWidth =
      logoWidth + spacing + Math.max(headerWidth, subHeaderWidth);
    const startX = (pageWidth - totalWidth) / 2;

    try {
      doc.addImage(logo, "PNG", startX, 8, logoWidth, logoHeight);
    } catch (e) {
      console.warn("Logo load skipped (small size optimization)");
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(headerText, startX + logoWidth + spacing, 14);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(subHeaderText, startX + logoWidth + spacing, 20);
  };


  const handleDownloadPDF = () => {
    if (paymentData.length === 0) {
      toast("No data to download", "ERROR");
      return;
    }

    const doc = new jsPDF({ orientation: "portrait", compress: true });
    const pageWidth = doc.internal.pageSize.getWidth();

    addPDFHeader(doc, pageWidth);

    autoTable(doc, {
      startY: 30,
      head: [["S.No", "Date", "Contractor", "Amount", "Remarks"]],
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        fontStyle: "bold",
      },
      body: paymentData.map((wag, i) => [
        i + 1,
        formatDate(wag.date),
        wag.contractor_name,
        wag.amount?.toFixed(2),
        wag.remarks
      ]),
    });

    doc.save("contractor_payment_report.pdf");
  };

  return (
    <Main>

      <PageContainer
        titlePage="Contractor Payment"
        buttonText="ADD"
        onButtonClick={() => setShowModal(true)}
      >

        {/* ------------------------------------------------------------- */}
        {/* PAYMENT FORM MODAL */}
        {/* ------------------------------------------------------------- */}

        <Modal
          visible={showModal}
          size="lg"
          onClose={handleCancel}
          headerText={
            paymentForm.id
              ? "Edit Contractor Payment"
              : "Add Contractor Payment"
          }
        >

          <ContractorPaymentForm
            paymentForm={paymentForm}
            contractors={contractors}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
          />

        </Modal>


        {/* ------------------------------------------------------------- */}
        {/* PAYMENT LIST */}
        {/* ------------------------------------------------------------- */}

        <CollapseCard title="Contractor Payment List">

          <ContractorPaymentList
            paymentData={paymentData}
            contractors={contractors}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            contractorId={filters.contractor_id}
            fromDate={filters.from_date}
            toDate={filters.to_date}
            handleFilterChange={handleFilterChange}
            handleFilter={handleFilter}
            handleClearFilter={handleClearFilter}
          />

        </CollapseCard>
           <div className="d-flex justify-content-end mb-2">
            <Button variant="success" onClick={handleDownloadPDF}>
              <Download /> Download PDF
            </Button>
          </div>
      </PageContainer>

    </Main>
  );
};

export default ContractorPayment;